import { createContext, ReactNode, useContext } from "react";

export interface PageHeaderState {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

interface PageHeaderContextValue {
  pageHeader: PageHeaderState | null;
  setPageHeader: (header: PageHeaderState | null) => void;
}

export const PageHeaderContext = createContext<PageHeaderContextValue | null>(
  null,
);

export function usePageHeaderContext() {
  return useContext(PageHeaderContext);
}
